import howBuyTemplate from './views/how-buy.html';
import cookiesTemplate from './views/cookies.html';
import faqTemplate from './views/faq.html';
import privacityPoliticsTemplate from './views/privacity-politics.html';
import termsTemplate from './views/terms.html';
import notFoundPage from './views/not-found-page.html';

// PAGOS Y ANTICIPOS
import quotationsTemplate from './views/payments-advances/quotations.html';
import purchaseOrderTemplate from './views/payments-advances/purchase-order.html';
import AdvancesOrdersTemplate from './views/payments-advances/orders.html'

routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.privacityPolitics', {
      url: "/politicas-de-privacidad",
      template: privacityPoliticsTemplate
    })
    .state('home.terms', {
      url: "/terminos-y-condiciones",
      template: termsTemplate
    })
    .state('home.cookies', {
      url: "/cookies",
      template: cookiesTemplate
    })
    .state('home.faq', {
      url: "/faq",
      template: faqTemplate
    })
    .state('home.404', {
      url: "/404",
      template: notFoundPage
    })

    // PAGOS Y ANTICIPOS
    // .state('home.quotations', {
    //   url: "/cotizaciones",
    //   template: quotationsTemplate
    // })
    // .state('home.purchaseOrder', {
    //   url: "/orden-de-compra",
    //   template: purchaseOrderTemplate
    // })
    // .state('home.AdvancesOrders', {
    //   url: "/pedidos",
    //   template: AdvancesOrdersTemplate
    // })

    .state('home.howBuy', {
      url: "/como-comprar",
      template: howBuyTemplate
    });

}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/static-views/static-views.config.js
 **/